import { render, staticRenderFns } from "./carRecord.vue?vue&type=template&id=51f596d4&scoped=true&"
import script from "./carRecord.vue?vue&type=script&lang=js&"
export * from "./carRecord.vue?vue&type=script&lang=js&"
import style0 from "./carRecord.vue?vue&type=style&index=0&id=51f596d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f596d4",
  null
  
)

export default component.exports